import React, { useEffect } from 'react';
import { addRoute } from '../../../GlobalRoutes';
import LinkList from '../../LinkList';
import Gallery from '../../Gallery';
import NavBar from '../../NavBar';
import { aboutMeLinks } from '../index';

import AboutMeFamily from '../Family/index';

export const traveledLinks = [
  { text: 'Travel Home', url: '/about-me-traveled' },
  { text: 'July 1976', url: '/about-me-traveled-july-1976' },
  { text: 'November 1976', url: '/about-me-traveled-november-1976' },
  { text: 'August 1977', url: '/about-me-traveled-august-1977' },
  { text: 'November 1978', url: '/about-me-traveled-november-1978' },
  { text: 'June 1979', url: '/about-me-traveled-june-1979' },
  { text: 'November 1980', url: '/about-me-traveled-november-1980' },
  { text: 'March 1981', url: '/about-me-traveled-march-1981' },
  { text: 'October 2016', url: '/about-me-traveled-october-2016' },
];

function Content(props) {
  return (
    <table cellPadding="10" width="100%" height="100%" border="0">
      <tbody>
        <tr>
          <LinkList links={aboutMeLinks} />
          <td valign="top">
          {(
            <>
              <div className="content"><NavBar links={traveledLinks} /></div>  
              <hr />
            </>
          )}                 
          <div className="content">{props.children}</div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

function AboutMeTraveledMarch1981() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - March 1981';
  });
  return (
    <Content>
      <p><font size="6">China March 1981</font></p>
      <Gallery req={require.context('./March_1981', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./March_1981/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledJuly1976() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - July 1976';
  });
  return (
    <Content>
      <p><font size="6">Germany, Switzerland and Austria July 1976</font></p>
      <Gallery req={require.context('./July_1976', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./July_1976/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledNovember1978() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - November 1978';
  });
  return (
    <Content>
      <p><font size="6">Afganistan November 1978</font></p>
      <Gallery req={require.context('./November_1978', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./November_1978/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledJune1979() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - June 1979';
  });
  return (
    <Content>
      <p><font size="6">Instanbul June 1979</font></p>
      <Gallery req={require.context('./June_1979', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./June_1979/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledNovember1976() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - November 1976';
  });
  return (
    <Content>
      <p><font size="6">Kenya and Tanzania November 1976</font></p>
      <Gallery req={require.context('./November_1976', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./November_1976/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledAugust1977() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - August 1977';
  });
  return (
    <Content>
      <p><font size="6">Bangkok, Singapore, Penang, Hong Kong, Hawaii to Scotland August 1977</font></p>
      <Gallery req={require.context('./August_1977', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./August_1977/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledNovember1980() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - November 1980';
  });
  return (
    <Content>
      <p><font size="6">Panama Canal,	San Blas Islands,	Columbia, Virgin Islands and San Juan, Puerto Rico November 1980</font></p>
      <Gallery req={require.context('./November_1980', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./November_1980/descriptions.json')} />
    </Content>
  );
}

function AboutMeTraveledOctober2016() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled - October 2016';
  });
  return (
    <Content>
      <p><font size="6">Madrid Spain October 2016</font></p>
      <Gallery req={require.context('./October_2016', false, /\.(jpe?g|png|gif|svg)$/i)} imageDescriptions={require('./October_2016/descriptions.json')} />
    </Content>
  );
}

export const AboutMeTraveled=() => {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Traveled';
  });

  return (
    <Content>
      <p><font size="6">Where I Have Traveled</font></p>
      <p className="left-justify">I am just getting started on this page. Here are most of the countries that I have been to. If you know of any good links for any of these countries please sent them to me at <a title="Email Tom" href="mailto:tom@tomsspot.com">Tom@TomsSpot.com</a></p>
      <p className="left-justify">In no particular order yet:<br/><br/>Scotland, England, Wales, <a href="/about-me-traveled-march-1981" title="Pictures of China Vacation">China</a>, <a href="/about-me-traveled-august-1977" title="Pictures of Bangkok August 1977 Vacation">Thailand</a>, <a href="/about-me-traveled-august-1977" title="Pictures of Singapore, Penang and Hong Kong August 1977 Vacation">Hong Kong</a>, <a href="/about-me-traveled-august-1977" title="Pictures of Singapore, Penang and Hong Kong August 1977 Vacation">Penang</a>, <a href="/about-me-traveled-august-1977" title="Pictures of Singapore, Penang and Hong Kong August 1977 Vacation">Singapore</a>, Malaysia, India, <a href="/about-me-traveled-july-1976" title="Pictures of Switzerland, Germany and Austria July 1976 Vacation">Switzerland</a>, <a href="/about-me-traveled-july-1976" title="Pictures of Switzerland, Germany and Austria July 1976 Vacation">Germany</a>, <a href="/about-me-traveled-july-1976" title="Pictures of Switzerland, Germany and Austria July 1976 Vacation">Austria</a>, Holland, France, Belgium, <a href="/about-me-traveled-november-1976" title="Pictures of Africa Vacation">Kenya</a>, <a href="/about-me-traveled-november-1976" title="Pictures of Africa Vacation">Tanzania</a>, Saudi Arabia, Bahrain, Iraq, Canada, Mexico, <a href="/about-me-traveled-november-1980" title="Pictures of Panama Canal Cruise">Colombia</a>, <a href="/about-me-traveled-november-1980" title="Pictures of Panama Canal Cruise">Aruba</a>, <a href="/about-me-traveled-november-1980" title="Pictures of Panama Canal Cruise">Panama</a>, <a href="/about-me-traveled-november-1980" title="Pictures of Panama Canal Cruise">San Blas Islands</a>, <a href="/about-me-traveled-november-1980" title="Pictures of Panama Canal Cruise">Virgin Islands</a>,  <a href="/about-me-traveled-november-1980" title="Pictures of Panama Canal Cruise">Puerto Rico</a>, Greece &amp; <a href="/about-me-traveled-october-2016" title="Pictures of Madrid Spain">Spain</a>.</p>
      <p className="left-justify">The scanning project has started.  However due to the large number of slides there are it is going to take some time to complete the project. Keep checking back from time to time to see the latest slides that have been added.</p>
    </Content>
  );
}


addRoute('/about-me-family', <AboutMeFamily />);
addRoute('/about-me-traveled', <AboutMeTraveled />);
addRoute('/about-me-traveled-July-1976', <AboutMeTraveledJuly1976 />);
addRoute('/about-me-traveled-november-1976', <AboutMeTraveledNovember1976 />);
addRoute('/about-me-traveled-august-1977', <AboutMeTraveledAugust1977 />);
addRoute('/about-me-traveled-november-1978', <AboutMeTraveledNovember1978 />);
addRoute('/about-me-traveled-june-1979', <AboutMeTraveledJune1979 />);
addRoute('/about-me-traveled-november-1980', <AboutMeTraveledNovember1980 />);
addRoute('/about-me-traveled-march-1981', <AboutMeTraveledMarch1981 />);
addRoute('/about-me-traveled-october-2016', <AboutMeTraveledOctober2016 />);

export default AboutMeTraveled;